import {
  useGetQuery,
  useLazyGetQuery,
  usePostMutation,
  usePutMutation,
  useDeleteMutation,
} from "slices/api";
import { FLOOR } from "tagTypes";

export const useFloorQuery = (query = {}, isFireSafety = false) =>
  useGetQuery({
    endpoint: isFireSafety ? "/firesafety-address/floor" : "/floor",
    query,
    tags: [FLOOR],
  });

export const useLazyFloorQuery = () => {
  const [getFloor, data] = useLazyGetQuery();
  const floor = async (query = {}) =>
    await getFloor(
      {
        endpoint: "/floor",
        query,
        tags: [FLOOR],
      },
      true
    ).unwrap();
  return [floor, data];
};

export const usePostFloorMutation = () => {
  const [floor, data] = usePostMutation();
  const addFloor = async (payload, query = {}) =>
    await floor({
      endpoint: "/floor",
      query,
      payload: payload || {},
      toastMessage: "Floor added successfully",
      tags: [FLOOR],
    }).unwrap();

  return [addFloor, data];
};

export const usePutFloorMutation = () => {
  const [floor, data] = usePutMutation();
  const updateFloor = async (payload, id, query = {}) =>
    await floor({
      endpoint: `/floor/${id}`,
      query,
      payload: payload || {},
      toastMessage: "Floor updated successfully",
      tags: [FLOOR],
    }).unwrap();
  return [updateFloor, data];
};

export const useDeleteFloorMutation = () => {
  const [floor, data] = useDeleteMutation();
  const deleteFloor = async (id, query = {}) =>
    await floor({
      endpoint: `/floor/${id}`,
      query,
      toastMessage: "Floor deleted successully",
      tags: [FLOOR],
    }).unwrap();
  return [deleteFloor, data];
};
